import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { SimpleHeader, SimpleTextCell } from "../MagazineEvents/Components";
import { TextFilter } from "../../components/Filters/TextFilter";
import FormItem from "../../components/FormItem";
import { AddressInputInbuilt } from "../../components/AddressInputInbuilt";
import SelectSimpleInbuilt from "../../components/SelectSimple/Filters/SelectSimpleInbuilt";
import { useGetSubdivisionListQuery } from "../../../middleware/usersApi";
import { formatAddress } from "../../../helpers/helper";

export const formFields = {
  searchParams: "searchParams",
  subdivisionAddress: "subdivisionAddress",
  subdivisionName: "subdivisionName",
  controlConsoles: "controlConsoles",
  userName: "userName",

  // Форма добавления/редактирования подразделения
  name: "name",
  address: "address",
  isGroup: "isGroup",
  subdivisionIds: "subdivisionIds",
  serviceAreas: "serviceAreas",
};

export const getColumns = ({ control, writeSearchDataToSessionStorage }) =>
  [
    {
      id: formFields.userName,
      numeric: false,
      enableSorting: false,
      isVisible: true,
      clickable: false,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.userName}`}
          input={(props) => (
            <TextFilter
              placeholder={"ФИО"}
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchUserNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.subdivisionName,
      label: "Подразделение",
      numeric: false,
      clickable: false,
      enableSorting: false,
      isVisible: true,
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          label={"Подразделение"}
          name={`${formFields.searchParams}.${formFields.subdivisionName}`}
          input={(props) => (
            <SubdivisionListSelect
              {...props}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchSubdivisionNameStorage"
            />
          )}
        />
      ),
    },

    {
      id: formFields.subdivisionAddress,
      numeric: false,
      enableSorting: false,
      isVisible: true,
      clickable: false,
      RowCell: (props) => <AdressesMultiCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          placeholder={"Адрес подразделения"}
          name={`${formFields.searchParams}.${formFields.subdivisionAddress}`}
          input={(props) => (
            <AddressInputInbuilt
              {...props}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchSubdivisionAddressStorage"
            />
          )}
        />
      ),
    },
    {
      id: formFields.controlConsoles,
      numeric: false,
      enableSorting: false,
      label: "Пульт(ы) и их статусы",
      size: "200px",
      isVisible: true,
      RowCell: (props) => <ArrayConsolesCell {...props} />,
      HeaderCell: () => <SimpleHeader name={"Пульт(ы) и их статусы"} />,
    },
  ].filter(({ isVisible }) => isVisible);

export const SubdivisionListSelect = (props) => {
  const [subdivisionsOptions, setSubdivisionsOptions] = useState([]);
  const { data = [] } = useGetSubdivisionListQuery({});

  useEffect(() => {
    if (!data.length) return;

    const formattedSubdivisionsList = data.map((item) => {
      return {
        id: item.id,
        name: `${item.name}, ${formatAddress(item.addressDto)}`,
      };
    });

    setSubdivisionsOptions(formattedSubdivisionsList);
  }, [data]);
  return <SelectSimpleInbuilt options={subdivisionsOptions} className="select-in-table small-light" {...props} />;
};
export const AdressesMultiCell = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!item || !Array.isArray(item)) {
    return null;
  }

  const maxVisibleItems = 3;
  const shouldShowToggle = item.length > maxVisibleItems;
  const visibleItems = isExpanded ? item : item.slice(0, maxVisibleItems);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          maxHeight: isExpanded ? "none" : `${3 * (24 + 8)}px`,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {visibleItems.map((element) => (
          <Typography key={element.id} className="table_row_text">
            {`${formatAddress(element)}` || ""}
          </Typography>
        ))}
      </div>

      {shouldShowToggle && (
        <Typography
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            alignSelf: "flex-start",
            color: "black",
            cursor: "pointer",
            padding: "4px 0",
            marginTop: "4px",
          }}
        >
          {isExpanded ? "Свернуть" : `Показать все (${item.length})`}
        </Typography>
      )}
    </div>
  );
};
const ArrayConsolesCell = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!item || !Array.isArray(item)) {
    return null;
  }

  const maxVisibleItems = 3;
  const shouldShowToggle = item.length > maxVisibleItems;
  const visibleItems = isExpanded ? item : item.slice(0, maxVisibleItems);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          maxHeight: isExpanded ? "none" : `${3 * (24 + 8)}px`,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {visibleItems.map((element) => (
          <Typography key={element.id} className="table_row_text">
            {`${element.name}, ${element.isOnLine ? "он-лайн" : "офф-лайн"}` || ""}
          </Typography>
        ))}
      </div>

      {shouldShowToggle && (
        <Typography
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            alignSelf: "flex-start",
            color: "black",
            cursor: "pointer",
            padding: "4px 0",
            marginTop: "4px",
          }}
        >
          {isExpanded ? "Свернуть" : `Показать все (${item.length})`}
        </Typography>
      )}
    </div>
  );
};
